import { Component } from "react"
import PropTypes from "prop-types"
import SelectTestCard from "components/shared/select_test_card"

class StripeElementsForm extends Component {
  constructor(props) {
    super(props)

    if (props.stripeEnabled) {
      this.stripe = Stripe(props.stripeKey)
      this.elements = this.stripe.elements()
    }

    this.createToken = this.createToken.bind(this)
  }

  componentDidMount() {
    const { onChange, stripeEnabled } = this.props

    const style = {
      base: {
        color: "#424242",
        iconColor: "#9E9E9E",
        lineHeight: "24px",
        fontFamily: "inherit",
        fontSmoothing: "antialiased",
        fontSize: 16,
        "::placeholder": {
          color: "#9E9E9E"
        }
      },
      invalid: {
        color: "#EF5350",
        iconColor: "#EF5350"
      }
    }

    if (stripeEnabled) {
      // Create an instance of the card Element
      this.card = this.elements.create("card", { style })

      // Add an instance of the card Element into the `card-element` <div>
      this.card.mount("#card-element")
      this.card.addEventListener("change", ({ error }) => {
        const displayError = document.getElementById("card-errors")
        if (error) {
          displayError.textContent = error.message
          onChange && onChange(error)
        } else {
          displayError.textContent = ""
          onChange && onChange({})
        }
      })
    }
  }

  createToken() {
    const { onError, onSuccess } = this.props
    this.stripe.createToken(this.card).then(event => {
      if (event.error) {
        // Inform the user if there was an error
        const errorElement = document.getElementById("card-errors")
        errorElement.textContent = event.error.message
        if (onError !== undefined) {
          onError(event.error)
        }
      } else {
        if (onSuccess !== undefined) {
          onSuccess(event)
        }
      }
    })
  }

  render() {
    const { hideFields, stripeTestmode, stripeTestmodeMessageDisabled } = this.props

    const formFields = (
      <div className={hideFields ? "hide" : ""}>
        <div className="mb-2 stripe-card-element-wrapper-admin-styles-are-different-than-ccw">
          <label
            htmlFor="card-element"
            className="label h5 pb-1 stripe-card-element-label-admin-styles-are-different-than-ccw"
          >
            Card Information
          </label>

          {stripeTestmode && !stripeTestmodeMessageDisabled && <SelectTestCard />}
          <div id="card-element" />

          <div id="card-errors" role="alert" />
        </div>
      </div>
    )

    return <div>{this.props.render({ formFields, createToken: this.createToken })}</div>
  }
}

const { string, bool, func, number } = PropTypes

StripeElementsForm.propTypes = {
  amountCents: number,
  currencyIsoCode: string,
  stripeAccountId: string,
  stripeKey: string,
  stripeEnabled: bool.isRequired,
  stripeTestmode: bool,
  stripeTestmodeMessageDisabled: bool,
  hideFields: bool,
  onChange: func,
  onSuccess: func,
  onError: func,
  render: func.isRequired
}

export default StripeElementsForm
